(() => {
  const content = window.PoptexTemplateContent;
  const products = window.PoptexProductContent;
  if (!content || !products) return;
  if (window.PoptexProductDetailUI) {
    document.querySelectorAll('[data-public-product]').forEach(window.PoptexProductDetailUI.mount);
    return;
  }
  const mount = (root) => {
    if (root.dataset.productInitialized === 'true') return;
    root.dataset.productInitialized = 'true';
    const node = (selector) => root.querySelector(selector);
    const copy = JSON.parse(node('[data-product-copy]').textContent);
    const rootUrl = root.dataset.rootUrl || '/';
    ['[data-product-styles]', '[data-product-sizes]', '[data-gallery-thumbnails]', '[data-series-gallery]'].forEach((selector) => root.querySelector(selector).replaceChildren());
    const maps = new Map();
    const removers = [];
    const imageJobs = new WeakMap();
    let disposed = false;
    let snapshot = null;
    let settled = false;
    let result = null;
    let previews = [];
    let patternScope = 'series';
    let filterGroup = '';
    let selectedImage = '';
    let selectedSize = '';
    let requestedImage = '';
    let imageSequence = 0;
    const desktop = window.matchMedia('(min-width: 1024px)');
    let patternPage = 0;
    let patternContext = '';
    const patternsPerPage = 40;
    const actionBar = node('.public-product__customize-bar');
    const actionObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(() => {
      const height = desktop.matches ? 0 : actionBar.getBoundingClientRect().height;
      root.style.setProperty('--product-action-height', `${height ? Math.ceil(height) + 8 : 0}px`);
    }) : null;
    if (actionBar) actionObserver?.observe(actionBar);
    const actionHome = document.createComment('mobile actions');
    actionBar.before(actionHome);
    const placeDesktop = () => {
      if (desktop.matches) { node('.public-product__info').append(actionBar); }
      else { actionHome.after(actionBar); }
    };
    placeDesktop();
    const mainImage = node('[data-main-image]');
    const mainPlaceholder = node('[data-main-placeholder]');
    const listen = (target, event, handler, options) => {
      target.addEventListener(event, handler, options);
      removers.push(() => target.removeEventListener(event, handler, options));
    };
    const text = (element, value) => {
      const next = typeof value === 'string' ? value : '';
      if (element.textContent !== next) element.textContent = next;
      return next;
    };
    const imageObserver = typeof IntersectionObserver === 'function' ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const job = imageJobs.get(entry.target);
        if (job) { job.active = true; job.display ? content.setDisplayImage(job.image, job.placeholder, { previewImages: { display: job.url } }) : content.setImage(job.image, job.placeholder, job.url); }
        imageObserver.unobserve(entry.target);
      });
    }, { rootMargin: '250px' }) : null;
    const lazyImage = (element, value, alt, display = false) => {
      const image = element.querySelector('img');
      const placeholder = element.querySelector('[data-image-placeholder]');
      image.alt = alt || '';
      const previous = imageJobs.get(element);
      const job = { image, placeholder, url: value || '', display, active: previous?.active || !imageObserver };
      imageJobs.set(element, job);
      if (job.active) display ? content.setDisplayImage(image, placeholder, { previewImages: { display: job.url } }) : content.setImage(image, placeholder, job.url);
      else imageObserver.observe(element);
    };
    const reconcile = (container, records, templateSelector, update) => {
      let items = maps.get(container);
      if (!items) { items = new Map(); maps.set(container, items); }
      const ids = new Set(records.map((record) => String(record.id)));
      items.forEach((element, id) => {
        if (!ids.has(id)) { imageObserver?.unobserve(element); element.remove(); items.delete(id); }
      });
      records.forEach((record, index) => {
        const id = String(record.id);
        let element = items.get(id);
        if (!element) { element = node(templateSelector).content.firstElementChild.cloneNode(true); items.set(id, element); }
        update(element, record, index);
        if (container.children[index] !== element) container.insertBefore(element, container.children[index] || null);
      });
    };
    const loadMain = (preview) => {
      const url = preview?.url || '';
      mainImage.alt = preview?.alt || result?.style?.name || '';
      const caption = node('[data-main-caption]');
      caption.hidden = !text(caption, preview?.caption);
      if (requestedImage === url) return;
      requestedImage = url;
      const sequence = ++imageSequence;
      node('[data-main-gallery]').setAttribute('aria-busy', 'true');
      content.setImage(mainImage, mainPlaceholder, url, { priority: 'high' }).then(loaded => {
        if (disposed || sequence !== imageSequence) return;
        if (!loaded) requestedImage = '';
        node('[data-main-gallery]').setAttribute('aria-busy', 'false');
      });
    };
    const selectImage = (id) => {
      selectedImage = id || '';
      const effect = content.images(result.template).find(image => image.label === 'main_effect');
      loadMain(effect ? { url: effect.url, alt: result.template.name, caption: result.template.name } : result.gallery.items[0]);
      const index = previews.findIndex((item) => item.id === selectedImage);
      text(node('[data-gallery-position]'), `${index < 0 ? '—' : String(index + 1).padStart(2, '0')} / ${String(previews.length).padStart(2, '0')}`);
      const container = node('[data-gallery-thumbnails]');
      const thumbnails = maps.get(container);
      thumbnails?.forEach((button, key) => button.setAttribute('aria-pressed', String(key === selectedImage)));

    };
    const stepImage = (direction) => {
      if (!previews.length) return;
      const index = previews.findIndex((item) => item.id === selectedImage);
      const next = index < 0 ? (direction > 0 ? 0 : previews.length - 1) : (index + direction + previews.length) % previews.length;
      selectTemplate(previews[next].id);
    };
    const readState = () => {
      const query = new URLSearchParams(window.location.search);
      return Object.fromEntries(['series', 'style', 'template'].map((key) => [key, key==='template'?(query.get('pattern')||query.get('template')):query.get(key)]));
    };
    const publicAddress = (state) => {
      const url = new URL(products.publicUrl(rootUrl, state), window.location.origin);
      new URLSearchParams(window.location.search).forEach((value, key) => {
        if (!['view', 'series', 'style', 'template', 'pattern'].includes(key)) url.searchParams.append(key, value);
      });
      return url.pathname + url.search;
    };
    const navigate = (state) => {
      const href = publicAddress(state);
      if (window.location.pathname + window.location.search !== href) window.history.pushState({}, '', href);
      render();
    };
    const selectTemplate = (id) => {
      if (!previews.some((preview) => preview.id === id)) return;
      const template = result.data.templatesById.get(id);
      if (!template) return;
      const linked = products.relatedStyles(template, result.data).filter((style) => style.groupId === result.group.id);
      if (linked.some((style) => style.id === result.style.id)) navigate({ ...result.state, template: id });
      else {
        // Keep the current series even when a shared template defaults to another series.
        const style = linked.find((item) => item.id === template.defaultProductSeriesId) || (linked.length === 1 ? linked[0] : null);
        navigate({ series: result.group.id, style: style?.id || null, template: id });
      }
    };
    const render = () => {
      if (disposed) return;
      node('[data-product-loading]').hidden = Boolean(snapshot) || settled;
      if (!snapshot && !settled) return;
      let input = readState();
      let automaticEntry = false;
      if (snapshot && Object.values(input).every((value) => value === null)) {
        const defaultCode = root.dataset.defaultProductCode || (/\/pages\/fleece\/?$/.test(window.location.pathname) ? 'penguin-fleece-blanket' : '');
        if (!defaultCode) {
          window.location.replace(new URL(`${rootUrl.replace(/\/?$/, '/')}pages/materials`, window.location.origin).href);
          return;
        }
        const style = products.catalog(snapshot).styles.find((item) => item.code === defaultCode);
        // An unpublished legacy product must remain unavailable, rather than open another series.
        input = { ...input, style: style?.id || defaultCode };
        automaticEntry = true;
      }
      result = products.resolve(snapshot, input);
      if (result.kind === 'choose') {
        const choices = result.choices.filter((style) => input.series === null || style.groupId === input.series);
        const style = choices.find((item) => item.id === result.template?.defaultProductSeriesId)
          || choices.find((item) => item.productType === 'BLANKET') || choices[0];
        result = products.resolve(snapshot, { ...input, series: style?.groupId || input.series, style: style?.id || '' });
        automaticEntry = true;
      }
      if (result.kind === 'detail') {
        // Style-only links (including customizer details) need a pattern for the hero.
        if (!result.template && !input.template) {
          const preview = result.templateGallery.find((item) => products.relatedStyles(result.data.templatesById.get(item.id), result.data).some((style) => style.id === result.style.id));
          if (preview) {
            result = products.resolve(snapshot, { ...result.state, template: preview.id });
            automaticEntry = true;
          }
        }
        const href = publicAddress(result.state);
        if (automaticEntry && window.location.pathname + window.location.search !== href) window.history.replaceState({}, '', href);
      }
      root.dataset.productState = result.kind;
      node('[data-product-content]').hidden = result.kind !== 'detail';
      node('[data-product-unavailable]').hidden = result.kind !== 'unavailable';
      if (result.kind !== 'detail') {
        // A response for an old product must not arrive after it becomes unavailable.
        imageSequence += 1;
        requestedImage = '';
      }
      if (result.kind === 'unavailable') {
        text(node('[data-unavailable-title]'), result.reason === 'no_product' ? copy.no_product : copy.unavailable);
        text(node('[data-unavailable-copy]'), result.reason === 'no_product' ? copy.no_product_help : copy.unavailable_help);
        return;
      }
      const { group, style, template } = result;
      if (filterGroup !== group.id) { filterGroup = group.id; patternPage = 0; patternScope = 'series'; selectedImage = ''; selectedSize = ''; }
      root.dataset.patternScope = patternScope;
      text(node('[data-product-name]'), group.name);
      node('[data-product-tier]').hidden = !text(node('[data-product-tier]'), copy[String(group.tier || '').toLowerCase()] || '');
      node('[data-product-intro]').hidden = !text(node('[data-product-intro]'), group.description);
      const detail = group.detailContent || {};
      const points = Array.isArray(detail.sellingPoints) ? detail.sellingPoints.filter((point) => typeof point === 'string' && point.trim()) : [];
      const selling = node('[data-product-selling]');
      selling.hidden = !points.length;
      if (selling.dataset.value !== JSON.stringify(points)) {
        selling.replaceChildren(...points.map((point) => { const item = document.createElement('li'); item.textContent = point; return item; }));
        selling.dataset.value = JSON.stringify(points);
      }
      reconcile(node('[data-product-styles]'), result.styles, '[data-style-template]', (button, item) => {
        button.dataset.productStyle = item.id;
        text(button, item.name);
        button.setAttribute('aria-pressed', String(item.id === style.id));
      });
      const sizes = Array.isArray(style.sizes) ? style.sizes.filter((size) => Number(size.widthInches) > 0 && Number(size.heightInches) > 0) : [];
      const sizeKey = (size) => `${size.widthInches}x${size.heightInches}`;
      selectedSize = new URLSearchParams(window.location.search).get('size') || '';
      if (!sizes.some((size) => sizeKey(size) === selectedSize)) selectedSize = sizes.length ? sizeKey(sizes[0]) : '';
      const sizesNode = node('[data-product-sizes]');
      node('[data-size-section]').hidden = !sizes.length;
      reconcile(sizesNode, sizes.map((size) => ({ ...size, id: sizeKey(size) })), '[data-size-template]', (item, size) => {
        const button = item.querySelector('button');
        button.dataset.productSize = size.id;
        button.setAttribute('aria-pressed', String(size.id === selectedSize));
        text(button.querySelector('strong'), `${size.widthInches}″ × ${size.heightInches}″`);
        button.querySelector('[data-size-label]').hidden = !text(button.querySelector('[data-size-label]'), size.label);
        button.querySelector('[data-size-usage]').hidden = !text(button.querySelector('[data-size-usage]'), size.usageDescription);
      });
      const customizeUrl = new URL(root.dataset.customizeUrl || `${rootUrl}?view=design`, window.location.origin);
      customizeUrl.searchParams.set('product', style.id);
      customizeUrl.searchParams.delete('templateId');
      customizeUrl.searchParams.delete('pattern');
      if (template) customizeUrl.searchParams.set('pattern', template.id);
      if (selectedSize) customizeUrl.searchParams.set('size', selectedSize);
      else customizeUrl.searchParams.delete('size');
      const pageParams = new URLSearchParams(window.location.search);
      const inquiryUrl = new URL(root.dataset.inquiryUrl || `${rootUrl}pages/contact-us`, window.location.origin);
      inquiryUrl.searchParams.set('source', 'product-detail');
      inquiryUrl.searchParams.set('product', style.id);
      if (template) inquiryUrl.searchParams.set('pattern', template.id);
      if (selectedSize) inquiryUrl.searchParams.set('size', selectedSize);
      for (const key of ['preview_theme_id', 'preview_key', '_fd', 'pb']) {
        if (pageParams.has(key)) {
          inquiryUrl.searchParams.set(key, pageParams.get(key));
          customizeUrl.searchParams.set(key, pageParams.get(key));
        }
      }
      inquiryUrl.hash = 'ContactUsForm';
      node('[data-product-inquiry]').href = inquiryUrl.href;
      node('[data-product-customize]').href = customizeUrl.href;
      root.querySelectorAll('[data-detail-field]').forEach((element) => {
        const field = element.dataset.detailField;
        const value = field === 'material' ? [detail.materialName, detail.materialDescription].filter(Boolean).join('\n\n') : detail[field];
        element.hidden = !text(element.querySelector('p'), value);
      });
      node('.public-product__details').hidden = ![...root.querySelectorAll('[data-detail-field]')].some((element) => !element.hidden);
      const stylePatternIds = new Set(result.patterns.map((pattern) => pattern.id));
      previews = result.templateGallery.filter((preview) => patternScope === 'series' || stylePatternIds.has(preview.id));
      root.querySelectorAll('[data-pattern-scope]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.patternScope === patternScope)));
      text(node('[data-pattern-count]'), copy.pattern_count.replace('__COUNT__', String(previews.length)));
      node('[data-pattern-empty]').hidden = Boolean(previews.length);
      node('[data-gallery-hint]').hidden = previews.length < 2;
      node('[data-gallery-arrows]').hidden = previews.length < 2;
      node('[data-main-template]').disabled = !previews.length;
      const context = [group.id, style.id, patternScope, template?.id || ''].join(':');
      const selectedIndex = previews.findIndex(preview => preview.id === template?.id);
      if (context !== patternContext) {
        patternContext = context;
        patternPage = selectedIndex < 0 ? 0 : Math.floor(selectedIndex / patternsPerPage);
      }
      const pageCount = Math.ceil(previews.length / patternsPerPage);
      patternPage = Math.min(patternPage, Math.max(0, pageCount - 1));
      const pagination = node('[data-pattern-pagination]');
      pagination.hidden = pageCount <= 1;
      node('[data-pattern-previous]').disabled = patternPage === 0;
      node('[data-pattern-next]').disabled = patternPage >= pageCount - 1;
      text(node('[data-pattern-page]'), copy.pattern_page.replace('__PAGE__', String(patternPage + 1)).replace('__TOTAL__', String(pageCount)));
      const thumbnails = node('[data-gallery-thumbnails]');
      thumbnails.hidden = !previews.length;
      reconcile(thumbnails, previews.slice(patternPage * patternsPerPage, (patternPage + 1) * patternsPerPage), '[data-gallery-thumbnail-template]', (button, preview) => {
        button.dataset.galleryImage = preview.id;
        button.setAttribute('aria-label', preview.alt);
        text(button.querySelector('[data-pattern-name]'), preview.alt);
        lazyImage(button, preview.url, preview.alt, true);
      });
      selectImage(template?.id);
      if (node('[data-breadcrumb-name]')) text(node('[data-breadcrumb-name]'), group.name);
      const editorial = node('[data-series-gallery]');
      node('[data-series-section]').hidden = !result.groupGallery.length;
      reconcile(editorial, result.groupGallery, '[data-series-gallery-template]', (element, preview, index) => {
        element.dataset.seriesImage = preview.id;
        text(element.querySelector('[data-story-number]'), String(index + 1).padStart(2, '0'));
        element.querySelector('h2').hidden = !text(element.querySelector('h2'), preview.title);
        element.querySelector('p').hidden = !text(element.querySelector('p'), preview.caption);
        lazyImage(element, preview.url, preview.alt);
      });
    };
    listen(root, 'click', (event) => {
      const target = event.target.closest('button');
      if (!target || !root.contains(target)) return;
      if (target.hasAttribute('data-pattern-previous') || target.hasAttribute('data-pattern-next')) {
        patternPage += target.hasAttribute('data-pattern-next') ? 1 : -1;
        render();
        if (target.disabled) node(target.hasAttribute('data-pattern-next') ? '[data-pattern-previous]' : '[data-pattern-next]').focus({ preventScroll: true });
        node('[data-pattern-section]').scrollIntoView({ block: 'start' });
      }
      else if (target.dataset.productSize) {
        selectedSize = target.dataset.productSize;
        const url = new URL(window.location.href);
        url.searchParams.set('size', selectedSize);
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
        render();
      } else if (target.dataset.productStyle) {
        const style = result.data.stylesById.get(target.dataset.productStyle);
        if (!style || style.id === result.style.id) return;
        const template = result.templateGallery.find(preview => products.relatedStyles(result.data.templatesById.get(preview.id), result.data).some(item => item.id === style.id))?.id || null;
        navigate({ series: style.groupId, style: style.id, template });
      } else if (target.dataset.patternScope) {
        patternPage = 0;
        patternScope = target.dataset.patternScope;
        selectedImage = '';
        render();
      }
      else if (target.dataset.galleryImage) selectTemplate(target.dataset.galleryImage);
      else if (target.hasAttribute('data-gallery-next') || target.hasAttribute('data-main-template')) stepImage(1);
      else if (target.hasAttribute('data-gallery-previous')) stepImage(-1);
    });
    listen(node('[data-main-gallery]'), 'keydown', (event) => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); stepImage(event.key === 'ArrowRight' ? 1 : -1); }
    });
    listen(desktop, 'change', () => { placeDesktop(); render(); });
    listen(window, 'popstate', render);
    const dispose = () => {
      if (disposed) return;
      disposed = true;
      imageSequence += 1;
      imageObserver?.disconnect();
      actionObserver?.disconnect();
      stopWatch?.();
      removers.forEach((remove) => remove());
      actionHome.after(actionBar);
      actionHome.remove();
      delete root.dataset.productInitialized;
    };
    listen(document, 'shopify:section:unload', (event) => { if (event.target === root || event.target.contains?.(root)) dispose(); });
    const stopWatch = content.watch(root, (value, complete) => { snapshot = value; settled = complete; render(); });
  };
  window.PoptexProductDetailUI = { mount };
  document.querySelectorAll('[data-public-product]').forEach(mount);
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.matches?.('[data-public-product]')) mount(event.target);
    event.target.querySelectorAll?.('[data-public-product]').forEach(mount);
  });
})();
